<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div class="form-edit-page row-space">
        <div class="row-start row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ objEdicao.cdlicitacao }}</div>
            </div>

            <div class="form-item">
                <FornecedorFrame :initId="idFornecedorInicial" v-model:idSelecionado="objEdicao.idfornecedor"/>
            </div>

            <div class="form-item-data">
                <label class="label-caption">Inicio Vigência</label>
                <input type="date" v-model="objEdicao.vigencia_dtinicio" />
            </div>

            <div class="form-item-data">
                <label class="label-caption">Fim Vigência</label>
                <input type="date" v-model="objEdicao.vigencia_dtfim" />
            </div>
        </div>


        <div class="row-start row-space">
            <div class="form-item">
                <label class="label-caption">Nome/Identificação</label>
                <input type="text" v-model="objEdicao.nmlicitacao" maxlength="100" v-uppercase />
            </div>

            <div class="form-item-char20">
                <label class="label-caption">Valor Mão de Obra</label>
                <input v-model="objEdicao.vlmo" v-decimal type="text" class="input-right" />
            </div>

            <div class="form-item-char20">
                <label class="label-caption">% Desconto</label>
                <input v-model="objEdicao.aldesconto" v-decimal type="text" class="input-right" />
            </div>
            
            <div class="form-item-char20">
                <label class="label-caption">Valor Limite</label>
                <input v-model="objEdicao.vllimite" v-decimal type="text" class="input-right" />
            </div>

            <div class="form-item">
                <label class="label-caption">Nro Licitação</label>
                <input type="text" v-model="objEdicao.nrlicitacao" maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item">
                <label class="label-caption">Nro Contrato</label>
                <input type="text" v-model="objEdicao.nrcontrato" maxlength="100" v-uppercase />
            </div>
            
            <div class="form-item">
                <label class="label-caption">Nro Autorização Fornecimento</label>
                <input type="text" v-model="objEdicao.nraf" maxlength="100" v-uppercase />
            </div>
        </div>     


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Informações</label>
                <textarea v-model="objEdicao.informacoes" maxlength="1000" rows="5" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end">
            <label for="ckativo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckativo" v-model="objEdicao.ckativo" true-value="S" false-value="N" />
        </div>


        <div class="row-end">
            <label for="ckmo">Mão de Obra</label>
            <input type="checkbox" class="input-checkbox" id="ckmo" v-model="objEdicao.ckmo" true-value="S" false-value="N" />
        </div>


        <div class="row-end row-space">
            <label for="ckpecas">Peças</label>
            <input type="checkbox" class="input-checkbox" id="ckpecas" v-model="objEdicao.ckpecas" true-value="S" false-value="N" />
        </div>


        <div class="row-end">
            <button @click="closeForm">Voltar</button>
            <button v-if="objEdicao.id" class="btn-cancel" @click="excluirRegistro">Excluir</button>
            <button class="btn-confirm" @click="salvarDados">Gravar</button>
        </div>
    </div>


    <ModalJustificativaTexto ref="modalJustificativa" />
</template>


<script setup>
import { ref, reactive, onMounted } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import FornecedorFrame from '@/components/frames/FornecedorFrame.vue';
import ModalJustificativaTexto from '@/components/modals/ModalJustificativaTexto.vue';

const emit=defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}})

const idFornecedorInicial = ref(0);
const isLoading = ref(false);
const modalJustificativa = ref(null);
const msgAlerta = ref(false);

const objEdicao = reactive({
    id: 0,
    idmunicipio: 0,
    idfornecedor: 0,
    cdlicitacao: 0,
    nmlicitacao: '',
    nrlicitacao: '',
    nrcontrato: '',
    nraf: '',
    vigencia_dtinicio: '',
    vigencia_dtfim: '',
    vlmo: 0,
    aldesconto: 0,
    vllimite: 0,
    informacoes: '',
    ckativo: 'S',
    ckmo: 'N',
    ckpecas: 'N',
    idlogin: 0
})


function closeForm() {emit('close')}


async function excluirRegistro(){
    const rModal = await modalJustificativa.value.show();
    if (!rModal.confirmado) return;

    try {
        isLoading.value = true;
        const r = await Api.genericDelete('licitacao', objEdicao.id, globalStore.idusuario);
        if (r) {
            emit('save');
            emit('close');
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function lerDados(){
    try{
        if (props.idEdicao === 0) return;
        isLoading.value = true;
        const req = await Api.getCadastroById('licitacao', props.idEdicao);
         if (req.length > 0) {
            Object.assign(objEdicao, req[0]);
            idFornecedorInicial.value = objEdicao.idfornecedor;
            objEdicao.aldesconto = Funcoes.formatDecimal(objEdicao.aldesconto);
            objEdicao.vllimite = Funcoes.formatDecimal(objEdicao.vllimite);
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;

    try {
        isLoading.value=true;

        const payload = {
            ...objEdicao,
            idmunicipio: globalStore.idmunicipio,
            idlogin: globalStore.idlogin,
            vlmo: Funcoes.decimalFromString(objEdicao.vlmo),
            aldesconto: Funcoes.decimalFromString(objEdicao.aldesconto),
            vllimite: Funcoes.decimalFromString(objEdicao.vllimite),
        };
        const response = await Api.genericPut('/cad/licitacao', payload);
        if (response.bolok != 1) throw new Error(response.erro);
        emit('save');
        emit('close');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


function validarDados(){
    let x = '';
    const vllimite = Funcoes.decimalFromString(objEdicao.vllimite);

    if (!objEdicao.idfornecedor) x+='\n-Informe o fornecedor';
    let r = Validar.data(objEdicao.vigencia_dtinicio, -360, 'Início da vigência');
    if (!r.ok) x += `\n-${r.msg}`;
    r = Validar.data(objEdicao.vigencia_dtfim, -360, 'Final da vigência');
    if (!r.ok) x += `\n-${r.msg}`;
    if (objEdicao.vigencia_dtfim < objEdicao.vigencia_dtinicio) x+='\n-Final da vigência menor que o início';
    if (!objEdicao.nmlicitacao || String(objEdicao.nmlicitacao).trim() === '') x += '\n-Informe o nome/identificação';
    if (vllimite <= 0) x += '\n-Informe valor limite corretamente';
    if (!objEdicao.nrlicitacao || String(objEdicao.nrlicitacao).trim() === '') x += '\n-Informe o número da licitação';
    
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}

onMounted(lerDados)
</script>